import {Order, OrderField} from "../../../../app/api/model/order";
import React from "react";
import {UseModal} from "../../../../hooks/useModal";
import UpdateDialog from "../../../../components/Dialog/UpdateDialog";
import {OrderUpdateCommentRequest, useOrderUpdateCommentMutation} from "../../../../app/api/api";

export interface OrderDetailsCommentProps {
    order?: Order;
    onSuccess?: () => void;
    modal: UseModal;
}

export default function OrderDetailsCommentForm({order, modal, onSuccess}: OrderDetailsCommentProps) {
    const [updateComment] = useOrderUpdateCommentMutation();
    const initialValues = {
        id: order?.id,
        comment: order?.comment,
    };

    return (
        <UpdateDialog
            titleKey={"action_updateComment"}
            inputFields={[
                {
                    translationKey: "generic_comment",
                    fieldName: OrderField.COMMENT,
                    multiline: true,
                    minRows: 10,
                    gridProps: {xs: 12},
                },
            ]}
            onSuccess={onSuccess}
            modal={modal}
            entity={order}
            initialValues={initialValues}
            onSubmit={async (payload: Partial<Order>) => {
                const requestData: OrderUpdateCommentRequest = {
                    id: payload.id!,
                    comment: payload.comment || "",
                };
                return updateComment(requestData).unwrap();
            }}
        />
    );
}
